export default __webpack_public_path__ + "static/media/IkonInvesteringsunivers.40bad87a.svg";